const FaqsData = [
  {
    no: `01.`,
    title: `Quais status removem o contato da list de contatos gerados?`,
    content: `Apenas os Status "Finalizado Cancelado" e "Concorrência Fechada" removem um contato da lista de contatos gerados.
        Ao informar um desses status, adicione uma mensagem e salve. O contato será removido da lista de contatos gerados.
        Mensagens, status e atualizações das informações de contato são mantidos independentemente.`,
    icon: `bx-help-circle`,
  },
  {
    no: `02.`,
    title: `O que acontece quando qualifico um contato?`,
    content: `Um contato qualificado, além de sair da lista de contatos gerados, é inserido na lista de Contatos Qualificados, 
    mantendo suas mensagens trocadas com o cliente, bem como status e datas de agendamentos.`,
    icon: `bx-help-circle`,
  },
  {
    no: `03.`,
    title: `Quais característica mantem um contato na lista de Clientes?`,
    content: `Contatos com projetos nos status de "Projeto Iniciado" e "Fechado Aprovado" são mantidos na lista de Clientes.
    Contatos com documentos de projetos nos status de "Iniciado" e "Aprovado" são mantidos na lista de Clientes.`,
    icon: `bx-help-circle`,
  },
  {
    no: `04.`,
    title: `Quais status removem um contato da "Lista de Qualificados?"`,
    content: `Apenas os tatus Concorrência Fechada e Finalizado Fechado removem um contato na lista de qualificados.`,
    icon: `bx-help-circle`,
  },
  {
    no: `05.`,
    title: `Quando envio um documento escolhendo a opção "PARA MIM", o cliente também recebe?`,
    content: `Não! Ao escolher "Enviar Apenas para MIM", o sistema enviará o documento selecionado para o e-mail de documentos ARQEVENTOS e para o seu e-mail apenas. O cliente não receberá nenhum e-mail.`,
    icon: `bx-help-circle`,
  },
  {
    no: `06.`,
    title: `Quando envio um documento escolhendo a opção "PARA MIM E PARA O CLIENTE", quem receberá os e-mails?`,
    content: `Um e-mail é enviado para o endereço de e-mail dos documentos ARQEVENTOS, com cópia para o seu e-mail e também com cópia para o e-mail do cliente configurado na tela do Projeto.`,
    icon: `bx-help-circle`,
  },
  {
    no: `07.`,
    title: `Como funciona o sistema de redirecionamentos de e-mail para o e-mail ARQEVENTOS?`,
    content: `O sistema usa este e-mail para enviar documentos para os clientes, utilizando como destinatário principal o e-mail preenchido na tela de configuração do projeto.\n
    Além disso, suponhamos que o cliente receba um e-mail com documentos em anexo. Se ele responder a essa conversa direcionando o envio para o e-mail ARQEVENTOS, qualquer e-mail encaminhado para esse endereço será entregue uma cópia aos e-mails administrativos "Anelise + Vanessa"."`,
    icon: `bx-help-circle`,
  },
  {
    no: `08.`,
    title: `Como saber se um documento gerado pelo sistema não contem erros?`,
    content: `O aconselhado seria, primeiramente, enviar um e-mail de documento escolhendo a opção "APENAS PARA MIM". Desta forma, o cliente não receberá o e-mail, e você poderá conferir o documento antes de usar a opção "ENVIAR PARA MIM E CLIENTE".

    Documentos com erros serão destacados em VERMELHO em seu conteúdo.
    
    Possível causa de um erro: falta de preenchimento de informações na tela do Projeto. Todas as informações contidas em "PROJETO" e em "FORMA DE PAGAMENTO" são usadas para preenchimento de informações nos documentos. O não preenchimento gera um VERMELHO dentro de onde ficaria a informação no documento.`,
    icon: `bx-help-circle`,
  },
];

export { FaqsData };
